export const RESISTRATION_FAILED_TEMPLATE = {
    MENSION1: "<@U05A7USV2AJ>",
    MENSION2: "<@U076WGAD4E4>",
    TEXT: "saleceforceの登録に失敗したため架電対応お願いします",
}
